import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.customer/picker/customer-picker-table.htm";
import customerConfig from "emun.customer/customer.config";
import sortOptions from "emun.customer/customer-container.sort-options";
import CustomerParser from "emun.customer/parser/customer-parser";
import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";
import ChangeRepPrompt from "emun.customer/customer-change-rep";

export const filters = customerConfig.filters;

export const views = {
  list: "table",
//  cards: "th-large"
};

export default class CustomerPickerController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.setCustIds();
    $ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.config = customerConfig;
    //$ctrl.viewSelectionsChanged(); //load()
  }

  templateUrl = () => `customer-picker-${this.query.view}.htm`;

  selectAll() {
    const $ctrl = this;
    $ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
    this.setCustIds();
  }
  clearAll() {
    this.selected = {};
    this.setCustIds();
  }
  canClear() {
    return Object.keys(this.selected).length;
  }

  isSelected(cust) {
    return !!this.selected[cust.id];
  }

  setCustIds() {
    this.custIds = Object.keys(this.selected || {});
  }

  selectionsLabel() {
    const { custIds: keys = [] } = this;
    if (keys.length > 4)
      return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
        4} more...`;
    if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
    return "No selections";
  }

  hasSelections = () => Object.keys(this.selected).length > 0;

  viewSelectionsChanged() {
    const $ctrl = this;
    const idIn = $ctrl.viewSelections
      ? Object.keys($ctrl.selected || {}).join(",")
      : null;
    $ctrl.query.clearRefinements(false);
    $ctrl.query.filter("IdIn", idIn);
  }

  toggle(cust) {
    const $ctrl = this;
    console.log("toggle", cust.id, $ctrl.selected, cust);

    if ($ctrl.single) {
      $ctrl.$close(cust);
    } else if (cust.id in $ctrl.selected) {
      delete $ctrl.selected[cust.id];
      $ctrl.onCustUnSelected &&
        $ctrl.onCustUnSelected({ $cust: cust, ...$ctrl });
    } else {
      $ctrl.selected[cust.id] = true;
      $ctrl.onCustSelected &&
        $ctrl.onCustSelected({ $cust: cust, ...$ctrl });
    }
    this.setCustIds();
  }
  select(cust) {
    const $ctrl = this;
    $ctrl.$close([cust]);
  }

  $onDestroy() {
    this.query.dispose();
  }

  applyTags() {
    const $ctrl = this;
    ApplyTagsPrompt({
      RetailerIds: $ctrl.custIds,
      title: `Apply Tags...`
    });
  }
  changeRep() {
    const $ctrl = this;
    ChangeRepPrompt.open({
      RetailerIds: $ctrl.custIds,
    });
  }

  parseCustomers() {
    const $ctrl = this;
    CustomerParser({}).then(custIds => {
		$ctrl.selected = {};
		custIds.forEach(custId => {
			$ctrl.toggle({id: custId});
		});
		$ctrl.viewSelections = true;
		$ctrl.viewSelectionsChanged();
	});
  }

  getAutoQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryRetailersJoin.json",
      tagTotalsUrl: `QueryRetailerTagTotals.json?RetailerIdsToTake=0&JsConfig=ExcludeDefaultValues`,
      pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
	  views,
	  criteria: $ctrl.criteria,
      view: "table",
      filters,
      sortOptions,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "Status,CompanyName,Id",
      autoLoad: true,
      append: false
    };
  }
}


